<nav class="breadcrumb-routes z-depth-0" background="section" apply="theme">
  <div class="nav-wrapper">
    <div class="col s12">
      <a class="breadcrumb pointer mouse-action-color-theme-focus mouse-action-color-theme-hover outline-focus"
        tabindex="0" [ngClass]="[selectedRoutes?.length > 0 ? 'color-body' : 'color-background bld']" apply="theme"
        (click)="showGroup(true, null, 0)" (keyup.enter)="showGroup(true, null, 0)">...</a>
      <ng-container *ngFor="let item of selectedRoutes || []; last as l; index as i">
        <a class="breadcrumb pointer mouse-action-color-theme-focus mouse-action-color-theme-hover outline-focus"
          tabindex="0" [ngClass]="[l ? 'color-background bld' : 'color-body']" apply="theme"
          (click)="showGroup(true, item, i + 1)" (keyup.Enter)="showGroup(true, item, i + 1)">
          {{(routes | arrayFilter:'id':item:'=')[0].descripcion}}
        </a>
      </ng-container>
    </div>
  </div>
</nav>
<!--  -->
<section style="position: relative;">
  <article style="position: absolute;" class="route-toggle pretty-scrollbar">
    <ng-container
      *ngFor="let item of (routeList[selectedRoutes.length > 0 ? (selectedRoutes[selectedRoutes.length - 1]) : 'gc_balanced'] || []) | arrayMultisort:([{ key: 'orden', type: 'number' }]);">
      <ng-container *ngTemplateOutlet="buttons; context: { item: item }">
      </ng-container>
    </ng-container>
  </article>
</section>
<div [id]="'neural-network'+instanceId" class="neural-network"></div>

<ng-template #buttons let-item="item">
  <div
    class="padding-all-5 center-all border-theme border-all tag-style-section mouse-action-tag-style-theme-focus mouse-action-tag-style-theme-hover pointer"
    style="height: 40px; overflow: hidden; width: 100px; border-radius: 5px;" apply="theme" tabindex="0"
    (click)="showGroup(true, item.id)" (keyup.Enter)="showGroup(true, item.id)">
    <p class="center-align fnt-9 padding-all-0 bld margin-top-0">
      {{item.descripcion}}
    </p>
  </div>
</ng-template>